export function LogoMark({ size = 36, bg = "#004D35", stroke = "#ffffff", accent = "#a8f0c6" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none">
      <rect width="40" height="40" rx="10" fill={bg} />
      <path d="M10 11 L20 28 L30 11" stroke={stroke} strokeWidth="3.5"
        strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <circle cx="20" cy="28" r="2.5" fill={accent} />
    </svg>
  );
}

export function LogoFull({ size = 36, markBg = "#004D35", markStroke = "#ffffff", textColor = "#004D35" }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
      <LogoMark size={size} bg={markBg} stroke={markStroke} />
      <span style={{
        fontSize: size * 0.52, fontWeight: 700, color: textColor,
        fontFamily: "Georgia, serif", letterSpacing: "-0.02em", lineHeight: 1,
      }}>Viysr</span>
    </div>
  );
}
